// src/api/user.js
import { apiFetch } from '@lib/api/apiClient';

/**
 * 사용자 목록 조회
 * @param {any} searchParam
 */
export async function getUser(searchParam) {
    const res = await apiFetch(`/user/list`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(searchParam)
    });

    if (!res.ok) {
        throw new Error('사용자 목록을 불러오지 못했습니다.');
    }

    return (await res.json()).data;
}